import type { ComponentDetail, ComponentLocation } from '../api/learningSession'

/**
 * Convert API component detail to ComponentLocation format
 */
export function toComponentLocation(type: string, location: string): ComponentLocation {
    if (type === 'video') {
        return 'video'
    }

    if (type === 'assignment') {
        return 'assignment'
    }

    switch (location) {
        case 'pre':
            return 'pre_quiz'
        case 'post':
            return 'post_quiz'
        case 'wrapup':
            return 'wrapup_quiz'
        case 'checkup':
            return 'checkup_quiz'
        default:
            return 'post_quiz'
    }
}

/**
 * Find the first incomplete enabled component, or first enabled if all complete
 */
export function findNextComponent(components: ComponentDetail[]): ComponentDetail | null {
    const enabledComponents = components.filter((c) => c.enabled)
    if (enabledComponents.length === 0) return null

    // Find first incomplete component
    const incompleteComponent = enabledComponents.find(
        (c) => !c.progress || c.progress.status !== 'completed'
    )

    // If all complete, return first enabled component for re-learning
    return incompleteComponent || enabledComponents[0]
}

/**
 * Find the next component after the current one
 */
export function findNextComponentAfter(
    components: ComponentDetail[],
    currentType: string,
    currentLocation: string
): ComponentDetail | null {
    const enabledComponents = components.filter((c) => c.enabled)
    const currentIndex = enabledComponents.findIndex(
        (c) => c.type === currentType && c.location === currentLocation
    )

    if (currentIndex === -1 || currentIndex >= enabledComponents.length - 1) {
        return null
    }

    return enabledComponents[currentIndex + 1]
}

/**
 * Check if all required components are completed
 */
export function areAllRequiredCompleted(components: ComponentDetail[]): boolean {
    return components
        .filter((c) => c.enabled && c.required)
        .every((c) => c.progress?.status === 'completed')
}

